import { render, staticRenderFns } from "./transfer-captain.vue?vue&type=template&id=a06638e2&scoped=true&"
import script from "./transfer-captain.vue?vue&type=script&lang=js&"
export * from "./transfer-captain.vue?vue&type=script&lang=js&"
import style0 from "./transfer-captain.vue?vue&type=style&index=0&id=a06638e2&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a06638e2",
  null
  
)

export default component.exports